import sanityClient from '@sanity/client'

const client = sanityClient({
  projectId: "8m0zf2my",
  dataset: "production",
  token: "sknoOmcblRrx29QmufNOSwdMV59wxhelh7Xt2DY80ev2v2eBr1WSzl2SzoTcH0BAKzDdZaZobvTSVHgl57K4qygxYIa74I5XPP8LqNcEP8accxvWltLRU3y7XJXdTMw9TFOGp6gxUdy2OJSLT3uNAqjcdwykxg7FVWXEVKoBUVGbKMHA1sEX", // or leave blank to be anonymous user
  useCdn: false // `false` if you want to ensure fresh data
});

export default client;